import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs';

import { RouteSegment } from '@core/enums/route-segment.enum';
import { selectIsGlobalChargersEnabled } from '@core/stores/auth/auth.selectors';

import { isDefined } from '@shared/utils/is-defined';

export const globalChargersEnabledCanActivateGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(selectIsGlobalChargersEnabled).pipe(
    filter(isDefined),
    take(1),
    map((isEnabled) => (isEnabled ? true : new RedirectCommand(router.createUrlTree(['/', RouteSegment.Sites]), { replaceUrl: true })))
  );
};
